import { call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import JourneyTemplateServices from 'shared/services/JourneyTemplateServices';

import {
  createJourneyTemplateData,
  getJourneyTemplateData,
  setJourneyTemplateData,
  actionFail,
  updateJourneyTemplateSuccess,
  updateJourneyTemplateFail,
  updateJourneyTemplateData,
  buildJourneyTemplatePage,
  setIndividualJourneyTemplateInfo
} from './journeyTemplate.redux';

import {
  TAction,
  TPaginationRequest,
  TCreateJourneyTemplate,
  TUpdateJourneyTemplate
} from 'shared/types';

import { openNotificationMessage } from '../../shared/utils/NotificationMessages';
import { NotificationMessages } from 'shared/enums';
import { AxiosResponse } from 'axios';

import { IJourneyTemplate } from 'shared/interfaces/journeyTemplate.interface';

function* getJourneyTemplate({ payload }: TAction<TPaginationRequest>) {
  try {
    const result: AxiosResponse<IJourneyTemplate[]> = yield call(
      JourneyTemplateServices.getJourneyTemplateInfo,
      payload
    );
    yield put(setJourneyTemplateData(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* createJourneyTemplate({ payload }: TAction<TCreateJourneyTemplate>) {
  try {
    yield call(
      JourneyTemplateServices.createJourneyTemplate,
      payload.journeyTemplateData
    );
    yield put(getJourneyTemplateData(payload?.pagination));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Journey Template was successfully created.'
    });
  } catch (error: any) {
    console.log('error', error);
    yield put(actionFail());
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data.message ||
        'Journey Template creation was unsuccessful.'
    });
  }
}

function* handleUpdateJourneyTemplate({
  payload
}: TAction<TUpdateJourneyTemplate>) {
  try {
    const result: AxiosResponse<IJourneyTemplate> = yield call(
      JourneyTemplateServices.updateJourneyTemplate,
      payload
    );
    yield put(updateJourneyTemplateSuccess(result));
    yield openNotificationMessage({
      type: NotificationMessages.Success,
      title: 'Success',
      message: 'Journey Template was successfully updated.'
    });
  } catch (error: any) {
    yield put(updateJourneyTemplateFail());
    console.log('error', error);
    yield openNotificationMessage({
      type: NotificationMessages.Error,
      title: 'Error',
      message:
        error?.response?.data?.message ||
        'Journey Template updating was unsuccesful.'
    });
  }
}

function* buildIndividualPage({ payload }: TAction<any>) {
  try {
    const result: AxiosResponse<IJourneyTemplate[]> = yield call(
      JourneyTemplateServices.getOneJourneyTemplate,
      payload.slug
    );
    yield put(setIndividualJourneyTemplateInfo(result));
  } catch (error) {
    console.log('error', error);
  }
}

function* JourneyTemplates() {
  yield takeLatest(getJourneyTemplateData.type, getJourneyTemplate);
  yield takeEvery(createJourneyTemplateData.type, createJourneyTemplate);
  yield takeEvery(updateJourneyTemplateData.type, handleUpdateJourneyTemplate);
  yield takeLatest(buildJourneyTemplatePage.type, buildIndividualPage);
}

export default JourneyTemplates;
